import React, { useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { errorHelper } from '../../../utils/tools';
import { Form, Row, Col, Button } from 'react-bootstrap';
import { editContainer, fetchContainers, checkContainerExists } from '../../../store/actions/container';

// Props from parent component
const EditContainer = ({ container, onClose }) => {
    const notifications = useSelector(state => state.notifications);
    const currentBranch = useSelector(state => state.branch.current);
    const dispatch = useDispatch();

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: { container: container, newContainer: '' },
        validationSchema: Yup.object({
            newContainer: Yup.string()
                .required('Nový názov nádoby je povinný')
                .min(3, 'Názov nádoby musí mať minimálne 3 znaky')
                .max(16, 'Názov nádoby môže mať maximálne 16 znakov')
                .test('checkDuplicateContainer', 'Nádoba s týmto názvom už existuje', async (value) => {
                    if (!value) return true;
                    try {
                        const result = await dispatch(checkContainerExists({ branchId: currentBranch, container: value }));
                        const exists = result.payload;
                        return !exists;
                    } catch (error) {
                        console.error('Error checking container:', error);
                        return false;
                    }
                })
        }),
        onSubmit: async (values) => {
            await handleSubmit(values);
        }
    });

    useEffect(() => {
        if (notifications && notifications.global.success) {
            formik.resetForm();
            onClose();
        }
    }, [notifications, formik, onClose]);

    const handleSubmit = async (values) => {
        if (currentBranch) {
            values.branchId = currentBranch;
            await dispatch(editContainer(values));
            await dispatch(fetchContainers(currentBranch));
        }
    };

    return (
        <Form onSubmit={formik.handleSubmit}>
        <h2>Upraviť nádobu</h2>
        <hr />
        <Row>
            <Col>
                <Form.Group className="mb-3" controlId="formBasicContainer">
                    <Form.Label>Pôvodný názov nádoby</Form.Label>
                    <Form.Control
                        type="text"
                        value={formik.values.container}
                        readOnly
                        disabled={true}
                    />
                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicNewContainer">
                    <Form.Label>Nový názov nádoby</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Nová nádoba:"
                        {...formik.getFieldProps('newContainer')}
                        isInvalid={formik.touched.newContainer && formik.errors.newContainer}
                    />
                    <Form.Control.Feedback type="invalid">
                        {formik.errors.newContainer}
                    </Form.Control.Feedback>
                </Form.Group>
            </Col>
        </Row>
        <Row className="mt-3">
            <hr />
            <Col className="d-flex justify-content-end">
                <Button
                    className='button-custom-large'
                    variant='primary'
                    type="submit"
                >
                    Upraviť nádobu
                </Button>
            </Col>
        </Row>
    </Form>
    );
};

export default EditContainer;
